export const removeScriptIfExists = (url: string): void => {
  const script = document.querySelector(`[src="${url}"]`);

  if (script) {
    script.remove();
  }
};
